import { useI18n } from '~/stores/i18n';

import availableLanguages from '../../resources/languages.json';
import { isCordova } from './platform';

export const startsWithLangCode = (pathname: string) =>
  availableLanguages.find(
    (langCode) =>
      pathname === `/${langCode}` || pathname.startsWith(`/${langCode}/`),
  );

export const getLocaleFromPathname = (pathname: string) =>
  startsWithLangCode(pathname) ?? undefined;

const getNewPath = (pathname: string, langCode: string) => {
  const langCodeInPath = startsWithLangCode(pathname);

  if (langCode !== 'en' && langCodeInPath !== langCode) {
    let newPathname = pathname;

    if (langCodeInPath) {
      newPathname = newPathname.substring(3);
    }

    newPathname = `/${langCode}${newPathname}`;
    return newPathname;
  }

  if (langCode === 'en' && langCodeInPath) {
    return `${pathname.substring(3)}`;
  }
  return pathname;
};

export const generatePathnameWithLangCode = (
  pathname: string,
  langCode: string,
) => {
  const newPathname = getNewPath(pathname, langCode);
  return newPathname.endsWith('/') ? newPathname : `${newPathname}/`;
};

export const generatePathname = (pathname: string) =>
  generatePathnameWithLangCode(pathname, useI18n.getState().lang);

export const convertPathToHashBased = (): string | undefined => {
  if (isCordova()) {
    return undefined;
  }
  const origin = window.location.origin;
  const href = window.location.href;
  const path = href.substring(origin.length);
  const hashParts = path.split('#');
  if (hashParts.length > 1) {
    const browserBasedPath = hashParts[0] || '/';
    const hashBasedPath = hashParts[1];
    if (hashBasedPath === '/') {
      return browserBasedPath;
    }
  }
  return undefined;
};

export const getPath = () => {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
};
